import { z } from 'zod';
export const creditTransactionKindSchema = z.enum(['debit', 'credit', 'adjustment']);
export const creditReasonSchema = z.enum([
    'job_run',
    'assistant_run',
    'plan_allocation',
    'topup_purchase',
    'refund',
    'manual_adjustment',
    'rollover_expiry',
    'trial_allocation',
    'guest_allocation',
]);
export const creditLedgerEntrySchema = z.object({
    id: z.string(),
    userId: z.string(),
    amount: z.number().int(),
    balanceAfter: z.number().int(),
    kind: creditTransactionKindSchema,
    reason: creditReasonSchema,
    metadata: z.record(z.string(), z.unknown()).optional(),
    createdAt: z.string().datetime(),
});
export const subscriptionPlanSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    monthlyCredits: z.number().int().positive(),
    rolloverLimit: z.number().int().nonnegative(),
    rolloverPolicy: z.enum(['limited', 'reset_monthly']).default('limited'),
    priceHalalas: z.number().int().nonnegative(),
    currency: z.enum(['SAR']),
    billingInterval: z.enum(['monthly']).default('monthly'),
    seatLimit: z.number().int().positive(),
    queuePriority: z.enum(['standard', 'priority', 'express']),
    supportLevel: z.enum(['community', 'email', 'priority']),
    features: z.array(z.string()),
    isDefault: z.boolean().default(false),
});
export const walletTopupConfigSchema = z.object({
    currency: z.enum(['SAR']),
    minAmountHalalas: z.number().int().positive(),
    maxAmountHalalas: z.number().int().positive(),
    suggestedAmountsHalalas: z.array(z.number().int().positive()).min(1),
    creditsPerSar: z.number().positive(),
    expiresAfterDays: z.number().int().positive(),
});
export const walletTopupQuoteSchema = z.object({
    amountHalalas: z.number().int().positive(),
    currency: z.enum(['SAR']),
    credits: z.number().int().positive(),
    expiresAfterDays: z.number().int().positive(),
});
export const walletPaymentMethodSchema = z.object({
    brand: z.string().min(1).nullable(),
    lastFour: z.string().min(1).nullable(),
    expMonth: z.string().min(1).nullable(),
    expYear: z.string().min(1).nullable(),
    cardholderName: z.string().min(1).nullable(),
    verifiedAt: z.string().datetime().nullable()
});
export const walletAutoRechargeSettingsSchema = z.object({
    enabled: z.boolean(),
    amountHalalas: z.number().int().positive().nullable(),
    thresholdCredits: z.number().int().nonnegative().nullable(),
    lastAttemptAt: z.string().datetime().nullable(),
    lastSuccessAt: z.string().datetime().nullable(),
    lastFailureAt: z.string().datetime().nullable(),
    lastFailureReason: z.string().min(1).nullable()
});
export const billingAccountSchema = z.object({
    paymentMethod: walletPaymentMethodSchema.nullable(),
    autoRecharge: walletAutoRechargeSettingsSchema,
    preferredAmountHalalas: z.number().int().positive().nullable()
});
export const subscriptionStatusSchema = z.enum([
    'pending',
    'active',
    'past_due',
    'paused',
    'canceled',
]);
//# sourceMappingURL=credit.js.map